import { applySequentialPlacement } from './applySequentialPlacement'
import { AutoArrangeHandler } from './types'

const getTimestamp = (value: Date | string | undefined): number | null => {
  if (!value) return null
  if (typeof value === 'string') return new Date(value).getTime()
  return value.getTime()
}

export const arrangeItemsByDate: AutoArrangeHandler = (items, cols, rows) => {
  const sortedItems = [...items].sort((a, b) => {
    const aTime = getTimestamp(a.createdAt)
    const bTime = getTimestamp(b.createdAt)

    // items without dates go to the end
    if (aTime === null && bTime === null) return 0
    if (aTime === null) return 1
    if (bTime === null) return -1

    return aTime - bTime
  })

  return applySequentialPlacement(sortedItems, cols, rows, items)
}
